const JobPaymentStatusEnum = {
  PAID: "PAID",
  PENDING: "PENDING"
};

export default JobPaymentStatusEnum;
